import { map } from 'rxjs/operators'
import { ofType, StateObservable } from 'redux-observable'
import { UIType } from '../../../actions/ui/uiTypes'
import { State, ReduxAction } from '../../../reducers/reducerType'
import { Observable } from 'rxjs'
import { fetchEventStreamDetails } from '../../../slices/eventStream/eventStreamSlice'

const eventStreamDetails$ = (actions$: Observable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  ofType(UIType.SHOW_STREAM_MODAL),
  map(() => fetchEventStreamDetails(state$.value.config.roomname))
)

export default eventStreamDetails$
